<template>
	<div class="style">
		<!--弹出框-->
		<el-dialog :title="dialogTitle":close-on-click-modal=false :visible.sync="dialogVisible" width="1000px" :close="handleClose">
			<div class="title">
				<span class="checktip">* </span>风格名称：
				<el-input v-model="dialogData.name" style="width: 230px;" placeholder="风格名称"></el-input>

			</div>
			<div class="title">
				<span class="checktip">* </span>风格备注：
				<el-input v-model="dialogData.remarks" style="width: 230px;" placeholder="风格备注"></el-input>
			</div>
			<div class="title">
				<span class="checktip">* </span>已选图片：
				<el-input v-model="dialogData.img.name" style="width: 230px;" placeholder="已选图片"></el-input>
			</div>
			<div class="dataTag">
				<!--零件筛选-->
				<div class="filtrateMain">
					<el-row :gutter="15" style="text-align: center;">
						<el-col :span="5">
							<el-input v-model="dialogImgData.name" placeholder="名称"></el-input>
						</el-col>
						<el-col :span="5" style="line-height: 40px;">
							<el-button type="primary" size="mini" @click="handleImgSearch()">查询</el-button>
							<el-button type="warning" size="mini" @click="handleImgReset()">重置</el-button>
						</el-col>
					</el-row>
					<!--筛选结束-->
				</div>
				<!--列表内容-->
				<div class="tableData" style="text-align: center;">
					<el-table
							ref="multipleTable"
							:data="imgLists"
							border
							style="width: 100%;border-bottom: 1px solid #ddd;">
						<el-table-column type="index" label="序号" width="50px">
						</el-table-column>
						<el-table-column prop="name" label="图片名称" width="171px">
						</el-table-column>
						<el-table-column prop="imgUrl" label="缩略图" width="85px">
							<template slot-scope="scope">
								<img :src="scope.row.imgUrl" class="img" height="29px" alt="缩略图"/>
							</template>
						</el-table-column>
						<el-table-column prop="status" label="状态" width="60px">
							<template slot-scope="scope">
								{{scope.row.status==1?'上架':'下架'}}
							</template>
						</el-table-column>
						<el-table-column prop="panoramaUrl" label="全景图链接" width="160px">
							<template slot-scope="scope">
								<input class="disabledInput" :value="scope.row.panoramaUrl" disabled v-if="scope.row.panoramaUrl"></input>
							</template>
						</el-table-column>
						<el-table-column prop="describe" label="备注" width="100px">
							<template slot-scope="scope">
								<input class="disabledInput" :value="scope.row.describe" disabled v-if="scope.row.describe"></input>
							</template>
						</el-table-column>
						<el-table-column prop="createTime" label="创建时间" width="151px">
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="addImgFn(scope.row)" style="color: #1ABC9C;">选择</a>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<!--分页-->
				<div class="page">
					<el-pagination
							:current-page="imgListArr.currentPage"
							:page-sizes="[3]"
							:page-size="imgListArr.pageSize"
							layout="total, prev, pager, next"
							:total="imgListArr.totalSize"
							@current-change="handleListCurrentChange"
							@size-change="handleListSizeChange">
					</el-pagination>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()">确 定</el-button>
		  </span>
		</el-dialog>
		<!--导航条-->
		<!--<div>
			<navZcy v-bind:num="5"></navZcy>
			<management></management>
		</div>
		-->

		<div class="dataTag">
			<div class="handle">
				<div class="fl">
					<img src="../assets/img/dataIcon.png" style="vertical-align: middle;" />
					<span class="" style="display: inline-block; vertical-align: middle;">数据列表</span>
				</div>
				<div class="handleBtn fr">
					<el-button type="primary" size="small" @click="handleAdd">添加</el-button>
					<el-button type="danger" size="small" @click="handleDelete(0,0)">批量删除</el-button>
				</div>
			</div>
			<!--列表内容-->
			<div class="tableData" style="text-align: center;">
				<el-table
					ref="multipleTable"
					:data="tableData"
					border
					@selection-change="handleSelectionChange"
					style="width: 100%;border-bottom: 1px solid #ddd;">
					<el-table-column type="selection" width="150px">
					</el-table-column>
					<el-table-column type="index" label="序号" width="200px">
					</el-table-column>
					<el-table-column prop="name" label="系列风格" width="250px">
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<a href="javascript:void(0)" @click="handleEdit(scope.$index, scope.row)" style="color: #1ABC9C;">编辑</a>
							<a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import management from './management.vue'
import navZcy from './nav.vue'
export default{
	data() {
		return {
			dialogTitle: '',
			dialogVisible: false,
			tableData: [],
			dialogData: {
				id:0,
				name:'',
				remarks:'',
				img:{
					id:0,
					name:'',
					imgMd5:'',
					imgUrl:'',
					description:'',
					panoramaUrl:'',
					status:0,
					createTime:'',
					modifyTime:'',
				}
			},
			multipleSelection: [],
			imgListArr: {
				currentPage: 1,
				pageSize: 3,
				totalSize: 0
			},
			dialogImgData:{},
			imgLists:[],
		}
	},
	methods: {
		//弹出框关闭
		handleClose: function(done) {
			done();
		},
		getStyle() {
			this.$http.get("zcvrVideoApi/imgList/getStyleFromDB/"+sessionStorage.getItem('sessionId'),{emulateJson:true}).then(
		  	(success)=>{
				console.log(success)
		  	    if(success.body.msg!="ok"){
	  					this.tableData = []
						this.$message({
							type: 'error',
							message: success.data.msg
						});
						if(success.data.msg=="该SessionId已经超时"){
				  			this.$message.error("登录超时！请重新登录");
				  			this.$router.push({path: '/',query: ''})
				  		}
  				}else {
  					this.tableData = success.body.data
  				}

  			},
  			(error)=>{
  				console.log("数据连接失败")
  			})
		},
		//添加图片风格
		handleAdd: function() {
			this.dialogTitle = "添加图片风格";
			this.dialogData={
				name: "",
				remarks:'',
				img:{
					id:0,
					name:'',
					imgMd5:'',
					imgUrl:'',
					description:'',
					panoramaUrl:'',
					status:0,
					createTime:'',
					modifyTime:'',
				}
			};
			this.dialogVisible = true;
			this.inquiryImg();
			setTimeout(function(){
				$('.input').focus()
			},100)
		},
		//编辑图片风格
		handleEdit: function(index, row) {
			this.dialogTitle = "编辑图片风格";
			this.dialogData = {
				id: row.id,
				name: row.name,
				remarks:row.remarks,
				img:row.img,
			};
			this.dialogVisible = true;
			this.inquiryImg()
			setTimeout(function(){
				$('.input').focus()
			},100)
		},
		//确定添加/编辑
		handleConfirm: function() {
			if(this.dialogData.name){
				let url = ""
				let data = {
					name: this.dialogData.name,
					remarks: this.dialogData.remarks,
					imageId:this.dialogData.img.name == '' ? 0 : this.dialogData.img.id,
				}
				if(this.dialogTitle == "添加图片风格"){
					url = "zcvrVideoApi/imgList/createStyle/"+sessionStorage.getItem('sessionId')
				}else{
					url = "zcvrVideoApi/imgList/updateStyle/"+sessionStorage.getItem('sessionId')
					data.id = this.dialogData.id
				}
				console.log(data)
				this.$http.post(url,data,{emulateJson:true}).then(
				  	(success)=>{
		  				console.log(success)
				  	    if(success.body.msg!="ok"){
								this.$message({
									type: 'error',
									message: success.data.msg
								});
								if(success.data.msg=="该SessionId已经超时"){
						  			this.$message.error("登录超时！请重新登录");
						  			this.$router.push({path: '/',query: ''})
						  		}
		  				}else {
							this.dialogVisible = false
		  					this.getStyle()
		  				}
		  			},
		  			(error)=>{
		  				console.log("数据连接失败")
		  			})
			}else{
				this.$message({
					type: 'error',
					message: '请输入图片风格名称'
				});
			}
		},
		//复选框选中
		handleSelectionChange: function(val){
			this.multipleSelection=[]
			for (let i=0; i<val.length; i++) {
				this.multipleSelection.push(val[i].id)
			}
		},
		//删除图片风格
		handleDelete: function(index, row) {
			let id = []
			if(row!=0){
				id[0] = row.id
			}else{
				id = this.multipleSelection
			}
			if(id.length>0){
				this.$confirm('此操作将永久删除该风格, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let url = "zcvrVideoApi/imgList/deleteStyle/"+sessionStorage.getItem('sessionId')+"/"+id
					this.$http.get(url,{emulateJson:true}).then(
				  			(success)=>{
//				  				console.log(success)
				  				if(success.body.msg=="ok"){
				  					this.$message({
							          message: '删除成功',
							          type: 'success'
							       });
							        this.getStyle()
				  				}else{
				  					this.$message({
							          message: success.data.msg,
							          type: 'error'
							        });
					  				if(success.data.msg=="该SessionId已经超时"){
							  			this.$message.error("登录超时！请重新登录");
							  			this.$router.push({path: '/',query: ''})
							  		}
				  				}
				  			},
				  			(error)=>{
				  				console.log("数据连接失败")
				  			}
				  		)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}else{
				this.$message({
					type: 'info',
					message: '请选择删除项'
				});
			}
		},
		inquiryImg: function(){
			var data = {
				name: this.dialogImgData.name,
				currentPage: this.imgListArr.currentPage,
				pageSize: this.imgListArr.pageSize
			}
			this.$http.post("zcvrVideoApi/image/inquiryImg/"+sessionStorage.getItem('sessionId'),data,{emulateJson:true}).then(
					(success)=>{
						console.log(success)
						if(success.body.msg!="ok"){
							this.$message({
								type: 'error',
								message: success.data.msg
							});
							if(success.data.msg=="该SessionId已经超时"){
								this.$message.error("登录超时！请重新登录");
								this.$router.push({path: '/',query: ''})
							}
						}else {
							this.imgListArr = success.body.data
							this.imgLists = this.imgListArr.items
							console.log(this.imgLists);
							if(!this.imgListArr.items){
								this.imgLists = []
							}
						}
					},
					(error)=>{
						console.log("数据连接失败")
					}
			)
		},
		handleListCurrentChange(cur){
			this.imgListArr.currentPage = cur
			this.inquiryImg()
		},
		handleListSizeChange(size) {
			this.imgListArr.pageSize = size
			this.inquiryImg()
		},
		addImgFn(row){
			const b = Object.assign({}, row);
			this.dialogData.img = b
		},
		handleImgSearch() {
			this.imgListArr.currentPage = 1
			this.inquiryImg()
		},
		//重置筛选
		handleImgReset() {
			this.dialogImgData = {}
		},
	},
	mounted() {
		this.getStyle()
	},
	components: {
		management,
		navZcy
	}
}
</script>

<style>
.fl {
	float: left;
}
.fr {
	float: right;
}
.cf {
	overflow: hidden;
}
.title{
	padding: 20px 0;
}
.dataTag{
	width: 900px;
	border: 1px solid #ccc;
	margin: auto;
	margin-top: 30px;
}
.dataTag .handle{
	height: 60px;
	line-height: 60px;
	background: #ededed;
	padding: 0 40px;
	border-bottom: 1px solid #ccc;
}
</style>
